export default __webpack_public_path__ + "static/media/C1.3e47dbcd.png";